<div class="ant-input-number-handler-wrap">
  <span unselectable="unselectable"
        class="ant-input-number-handler ant-input-number-handler-up"
        (mousedown)="up($event)"
        (mouseup)="stop()"
        (mouseleave)="stop()"
        [class.ant-input-number-handler-up-disabled]="disabledUp">
    <i nz-icon nzType="up" class="ant-input-number-handler-up-inner"></i>
  </span>
  <span unselectable="unselectable"
        class="ant-input-number-handler ant-input-number-handler-down"
        (mousedown)="down($event)"
        (mouseup)="stop()"
        (mouseleave)="stop()"
        [class.ant-input-number-handler-down-disabled]="disabledDown">
    <i nz-icon nzType="down" class="ant-input-number-handler-down-inner"></i>
  </span>
</div>
<div class="ant-input-number-input-wrap">
  <input #inputElement
         autocomplete="off"
         class="ant-input-number-input"
         [attr.id]="nzId"
         [disabled]="nzDisabled"
         [attr.min]="nzMin"
         [attr.max]="nzMax"
         [placeholder]="nzPlaceHolder"
         [attr.step]="nzStep"
         (keydown)="onKeyDown($event)"
         (keyup)="onKeyUp()"
         [ngModel]="displayValue"
         (ngModelChange)="onModelChange($event)">
</div>